import { render } from "./QuickSearchNewsCardElement.vue?vue&type=template&id=20c2df4c&scoped=true"
import script from "./QuickSearchNewsCardElement.vue?vue&type=script&lang=js"
export * from "./QuickSearchNewsCardElement.vue?vue&type=script&lang=js"

import "./QuickSearchNewsCardElement.vue?vue&type=style&index=0&id=20c2df4c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2Fquick_search%2Fcards%2FQuickSearchNewsCardElement.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c2df4c"]])

export default __exports__